module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-login-v3 layout-full th"
  }, [_c('div', {
    staticClass: "page vertical-align text-xs-center"
  }, [_c('div', {
    staticClass: "page-content vertical-align-middle"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [(_vm.isLoading) ? _c('div', {
    staticClass: "card-stat"
  }, [_c('loading-indicator')], 1) : _c('div', [(this.step === this.stepEnum.teamList) ? _c('team-list-form', {
    key: "namespace-login",
    attrs: {
      "teams": _vm.teams
    },
    on: {
      "selectTeam": _vm.submitOauthForm,
      "loginOtherTeam": _vm.onLoginOtherTeam
    }
  }) : _c('div', [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmit($event)
      }
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade-in",
      "mode": "out-in",
      "appear": ""
    }
  }, [(this.step === this.stepEnum.namespaceForm) ? _c('div', {
    key: "team-login",
    staticClass: "team-form"
  }, [_c('h3', {
    staticClass: "title title-login"
  }, [_vm._v(_vm._s(_vm.$t('login.action.enterTeamURL')))]), _vm._v(" "), _c('form-group', {
    attrs: {
      "error": _vm.formErrors.first('namespace')
    }
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "input-group-addon form-group-mobile"
  }, [_vm._v(_vm._s((_vm.baseURL + "/")))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.namespace),
      expression: "user.namespace"
    }],
    staticClass: "form-control form-group-mobile",
    attrs: {
      "type": "text",
      "id": "namespace",
      "placeholder": "Team URL"
    },
    domProps: {
      "value": _vm._s(_vm.user.namespace)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.namespace = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-block btn-lg m-t-40",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.$t('action.continue')) + " "), _c('span', {
    staticClass: "glyphicon glyphicon-chevron-right"
  })]), _vm._v(" "), _c('div', {
    staticClass: "login-help"
  }, [_c('p', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.$t('login.labels.dontHaveAccount')) + " "), _c('u', [_c('router-link', {
    staticClass: "btn btn-link btn-register",
    attrs: {
      "to": "register"
    }
  }, [_vm._v(_vm._s(_vm.$t('login.action.registerNewAccount')))])], 1)])])], 1) : (this.step === this.stepEnum.loginForm) ? _c('div', {
    key: "user-login",
    staticClass: "user-form"
  }, [_c('h3', {
    staticClass: "title title-login"
  }, [_vm._v(_vm._s(_vm.$t('login.labels.prefixLogin')) + " "), _c('span', {
    staticClass: "text-uppercase blue-600"
  }, [_vm._v(_vm._s(_vm.user.namespace))]), _vm._v(" " + _vm._s(_vm.$t('login.labels.subfixLogin')))]), _vm._v(" "), _c('alert', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoginFailed),
      expression: "isLoginFailed"
    }],
    attrs: {
      "alertClass": "alert-dismissible",
      "type": "danger"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.loginFailedText))])]), _vm._v(" "), _c('form-group', {
    attrs: {
      "error": _vm.formErrors.first('email')
    }
  }, [_c('label', {
    attrs: {
      "for": "email"
    }
  }, [_vm._v(_vm._s(_vm.$t('account.labels.email')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.email),
      expression: "user.email"
    }],
    ref: "emailInput",
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "id": "email",
      "placeholder": _vm.$t('account.labels.email')
    },
    domProps: {
      "value": _vm._s(_vm.user.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('form-group', {
    attrs: {
      "error": _vm.formErrors.first('password')
    }
  }, [_c('label', {
    attrs: {
      "for": "password"
    }
  }, [_vm._v(_vm._s(_vm.$t('account.labels.password')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.password),
      expression: "user.password"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "id": "password",
      "placeholder": _vm.$t('account.labels.password')
    },
    domProps: {
      "value": _vm._s(_vm.user.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.password = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-block btn-primary btn-lg btn-submit",
    class: {
      'btn-default': _vm.isLoggingIn
    },
    attrs: {
      "type": "submit",
      "disabled": _vm.isLoggingIn
    }
  }, [(_vm.isLoggingIn) ? _c('div', {
    staticClass: "loader vertical-align-middle loader-circle loader-form"
  }) : _vm._e(), _vm._v(" " + _vm._s(_vm.$t('action.login')) + "\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "login-help"
  }, [_c('router-link', {
    staticClass: "btn btn-link btn-block pull-right",
    attrs: {
      "to": ("/" + (this.user.namespace) + "/forgot")
    }
  }, [_vm._v(_vm._s(_vm.$t('forgot.action.forgotPassword')))]), _vm._v(" "), _c('p', {
    staticClass: "text-center"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('login.labels.dontHaveAccountOnTeam')))]), _c('br'), _vm._v(_vm._s(_vm.$t('login.labels.contactTeamAdmin')))])], 1)], 1) : _vm._e()])], 1)])], 1), _vm._v(" "), _c('form', {
    ref: "oauthForm",
    attrs: {
      "method": "POST",
      "action": _vm.oauthFormURL
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accessToken),
      expression: "accessToken"
    }],
    attrs: {
      "type": "hidden",
      "name": "access_token"
    },
    domProps: {
      "value": _vm._s(_vm.accessToken)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.accessToken = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _vm._m(1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "brand"
  }, [_c('img', {
    staticClass: "brand-img",
    attrs: {
      "src": "/static/images/byteark-loading-white.png",
      "alt": "logo account",
      "width": "180"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "brand-text font-size-24 grey-100"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "page-copyright page-copyright-inverse"
  }, [_c('p', [_vm._v("Service by ByteArk")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-90f2b200!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/login/Login.vue
// module id = 552
// module chunks = 1